import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Primitives";
import { scrollToId } from "../../lib/site";

const LINKS = [
  ["sobre", "Sobre"],
  ["servicos", "Serviços"],
  ["metodo", "Método"],
  ["resultados", "Resultados"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 1.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled ? "border-b border-white/10 bg-[#0a0a0c]/75 backdrop-blur-xl" : "border-b border-transparent"}`}
      data-testid="site-nav"
    >
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 md:h-20 md:px-10">
        <button onClick={() => go("top")} className="flex items-center gap-3" data-testid="nav-logo">
          <Logo />
          <span className="font-display text-xl font-800 uppercase leading-none tracking-wide">
            Carlos <span className="text-[var(--red)]">Motta</span><span className="block text-[11px] font-mono font-normal tracking-[0.12em] text-zinc-400">Personal Trainer</span>
          </span>
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`}
              className="group relative font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors hover:text-white">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[var(--red)] transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button onClick={() => go("agendar")} data-testid="nav-cta-agendar"
            className="hidden items-center gap-2 bg-[var(--red)] px-5 py-3 font-display text-base font-800 uppercase tracking-wider text-[#0a0a0c] transition-transform hover:-translate-y-0.5 sm:flex">
            Aula experimental <ArrowUpRight className="h-4 w-4" />
          </button>
          <button onClick={() => setOpen(!open)} className="p-2 lg:hidden" data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }}
            className="overflow-hidden border-t border-white/10 bg-[#0a0a0c] lg:hidden" data-testid="nav-mobile-menu">
            <div className="flex flex-col px-5 py-6">
              {LINKS.map(([id, label]) => (
                <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-link-${id}`}
                  className="border-b border-white/10 py-4 text-left font-display text-3xl font-800 uppercase">
                  {label}
                </button>
              ))}
              <button onClick={() => go("agendar")} data-testid="nav-mobile-cta"
                className="mt-6 bg-[var(--red)] py-4 font-display text-xl font-800 uppercase text-[#0a0a0c]">
                Agendar aula experimental
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
